import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useGet } from "../api/useApi";
import { API_ROUTES } from "../api/apiRoutes";

const Categories = () => {
  const navigate = useNavigate();

  const {
    data: models,
    loading: loadingGetModels,
    execute: getModels,
  } = useGet(API_ROUTES.MODEL.GET_FEATURED, {
    onError: (error) => {
      console.error("Error fetching models:", error);
    },
  });

  useEffect(() => {
    getModels();
  }, []);

  return (
    <section id="about">
      {
        loadingGetModels ? (
          <div className="spinner-container">
            <div className="spinner" />
          </div>
        ) : (
          <div className="categories">
            {models?.value?.map((c, i) => {
              const productImage = c?.products?.[0]?.product_images?.[0]?.file_url || 'https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/287fa4ca01567cbe565bb9eb600924278ce8fcbd6ad04d61dfc4831bb33ac13fbb3d8a6cfc6c8ff624a81901e5385247feae3a4280b4d50a8dd9bc4f636997e5d92a00a5635c69071a1d130008d0f5ddbf2cc8a6c1047cd0ebcfaf49c0db12236c24f3b4899d9656701102f3973f5ac2d7de48daa57473a07525/file-1779504527539.avif';
              return (
                  <div
                    key={i}
                    className="cat-card"
                    onClick={() =>
                      navigate(
                        `/watches?brand=${encodeURIComponent(c?.brand?.name)}&model=${c?.id}`,
                      )
                    }
                  >
                    <img className="cat-card-bg" src={productImage} alt={c?.name} />
                    <div className="cat-card-overlay" />
                    <div className="cat-content">
                      <div className="cat-label">{c?.brand?.name}</div>
                      <div className="cat-title">{c?.name}</div>
                    </div>
                  </div>
                )
            })}
          </div>
        )
      }
    </section>
  );
};

export default Categories;
